import React from 'react'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Popover from '@mui/material/Popover'

interface IListItemProps {
  isMobileWidth: boolean
  selected: boolean
  label: string
  icon: React.ReactNode
  disabled?: boolean
  disableText?: string
  isSubItem?: boolean
  toggleDrawerOpen(): void
  onNavigate(): void
}

const ListItem: React.FC<IListItemProps> = ({
  isMobileWidth,
  selected,
  label,
  icon,
  disabled,
  disableText,
  isSubItem,
  toggleDrawerOpen,
  onNavigate,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null)
  const isPopoverOpen = Boolean(anchorEl)

  return (
    <div
      onMouseEnter={(event) => disabled && setAnchorEl(event.currentTarget)}
      onMouseLeave={() => setAnchorEl(null)}
    >
      <ListItemButton
        sx={{ pl: isSubItem ? 4 : 2 }}
        disabled={disabled}
        selected={selected}
        onClick={() => {
          isMobileWidth && toggleDrawerOpen()
          onNavigate()
        }}
      >
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={label} />
      </ListItemButton>
      <Popover
        sx={{ pointerEvents: 'none' }}
        open={isPopoverOpen}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={() => setAnchorEl(null)}
        disableRestoreFocus
      >
        <div style={{ margin: '10px' }}>{disableText}</div>
      </Popover>
    </div>
  )
}

export default ListItem
